import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VToolbar,
                    { attrs: { flat: "" } },
                    [
                      _c(VToolbarTitle, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "title primary--text text--darken-1 text-no-wrap mt-0",
                          },
                          [_vm._v(" GRÁFICOS ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c("bubble-chart", {
                    staticClass: "bubble-chart",
                    attrs: {
                      dados: _vm.dadosGraficos.bubbleChart,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoDiagnostico}`,
                      "descricao-eixo-x": "COMPORTAMENTO",
                      "descricao-eixo-y": "RESPONSABILIDADE",
                      titulo:
                        "Matriz de Desempenho - Comportamento x Responsabilidade",
                      "is-get-svg": _vm.isGetSvg,
                    },
                    on: { svg: (value) => (_vm.svg = value) },
                  }),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-center" },
                [
                  _c(
                    VCol,
                    [
                      _c(
                        VRow,
                        { ref: "graficos", staticClass: "justify-center" },
                        [
                          _c("gauge-chart-cds", {
                            staticClass: "gauge-chart",
                            attrs: {
                              dados: _vm.dadosGraficos.gaugeChart,
                              "descricao-titulo": _vm.tituloGraficoGauge,
                              fonte: `Fonte: Sistema Desenvolva, ${_vm.anoDiagnostico}`,
                              titulo: _vm.tituloGraficoGauge,
                              descricao:
                                "<span style='font-style: italic'>(Comportamental x Responsabilidade)/10</span>",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-center" },
                [_c("legenda-cds")],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-0",
                        attrs: {
                          "disable-pagination": _vm.tipo === "SERVIDOR",
                          headers: _vm.headers,
                          "hide-default-footer": _vm.tipo === "SERVIDOR",
                          items: _vm.desempenhosServidores,
                          search: _vm.opcoes.pesquisa,
                          "sort-by": _vm.opcoes.ordenarPor,
                          "sort-desc": _vm.opcoes.decrescente,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function () {
                                return [
                                  _c(
                                    VRow,
                                    { staticClass: "mb-2" },
                                    [
                                      _c(
                                        VToolbar,
                                        { attrs: { flat: "" } },
                                        [
                                          _c(VToolbarTitle, [
                                            _c(
                                              "h2",
                                              {
                                                staticClass:
                                                  "title primary--text text--darken-1 text-no-wrap",
                                              },
                                              [_vm._v(" RESULTADOS ")]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.tipo === "UNIDADE"
                                    ? _c(
                                        VRow,
                                        [
                                          _c(
                                            VCol,
                                            { attrs: { cols: "12", md: "4" } },
                                            [
                                              _c("app-sort", {
                                                model: {
                                                  value: _vm.opcoes,
                                                  callback: function ($$v) {
                                                    _vm.opcoes = $$v
                                                  },
                                                  expression: "opcoes",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VCol,
                                            { attrs: { cols: "12", md: "4" } },
                                            [
                                              _c(VSelect, {
                                                attrs: {
                                                  items: _vm.situacoes,
                                                  "item-text": "text",
                                                  "item-value": "id",
                                                  label: "Situação:",
                                                  "prepend-icon": "filter_list",
                                                },
                                                model: {
                                                  value: _vm.situacao,
                                                  callback: function ($$v) {
                                                    _vm.situacao = $$v
                                                  },
                                                  expression: "situacao",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VCol,
                                            { attrs: { cols: "12", md: "4" } },
                                            [
                                              _c("app-search", {
                                                model: {
                                                  value: _vm.opcoes,
                                                  callback: function ($$v) {
                                                    _vm.opcoes = $$v
                                                  },
                                                  expression: "opcoes",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: `item.tipo`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.chefia ? "GESTOR" : "SERVIDOR"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaComportamental`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(item.notaAgrupada)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.notaResponsabilidade`,
                              fn: function ({ item }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("decimal")(
                                          item.notaAgrupadaResponsabilidade
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.resultado`,
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        item.cds >= 9 ? "font-weight-bold" : "",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm._f("decimal")(item.cds))
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: `item.naoAtende`,
                              fn: function ({ item }) {
                                return [
                                  item.cds < 4
                                    ? _c(
                                        VIcon,
                                        { attrs: { color: "grey" } },
                                        [_vm._v(" check_box ")]
                                      )
                                    : _c(
                                        VIcon,
                                        { attrs: { color: "grey" } },
                                        [_vm._v(" check_box_outline_blank ")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: `item.emDesenvolvimento`,
                              fn: function ({ item }) {
                                return [
                                  item.cds >= 4 && item.cds < 8
                                    ? _c(
                                        VIcon,
                                        { attrs: { color: "grey" } },
                                        [_vm._v(" check_box ")]
                                      )
                                    : _c(
                                        VIcon,
                                        { attrs: { color: "grey" } },
                                        [_vm._v(" check_box_outline_blank ")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: `item.atende`,
                              fn: function ({ item }) {
                                return [
                                  item.cds > 8
                                    ? _c(
                                        VIcon,
                                        { attrs: { color: "grey" } },
                                        [_vm._v(" check_box ")]
                                      )
                                    : _c(
                                        VIcon,
                                        { attrs: { color: "grey" } },
                                        [_vm._v(" check_box_outline_blank ")]
                                      ),
                                ]
                              },
                            },
                            _vm.tipo === "UNIDADE"
                              ? {
                                  key: `body.append`,
                                  fn: function () {
                                    return [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              align: "right",
                                              colspan: "3",
                                            },
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey--text text--darken-2",
                                              },
                                              [_vm._v("MÉDIA")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.mediaComportamental
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.mediaResponsabilidade
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.mediaCds
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              align: "right",
                                              colspan: "3",
                                            },
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey--text text--darken-2",
                                              },
                                              [_vm._v("DESVIO PADRÃO")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.desvioPadraoComportamental
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.desvioPadraoResponsabilidade
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("decimal")(
                                                    _vm.desvioPadraoCds
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      }),
                      _c(VDivider),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "justify-end mb-1" },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { "max-width": "400", top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                VBtn,
                                _vm._g(
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getRelatorio(
                                          _vm.desempenhosServidores,
                                          _vm.tipo
                                        )
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c(VIcon, [_vm._v("get_app")]),
                                  _vm._v(" BAIXAR PDF "),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Clique para baixar o relatório dos dados em formato PDF."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }